import storage from '../../utils/storage'
import { detectB3User } from '../../utils/util'
import { SET_CHECKOUT_CREDIT_SETTINGS, SET_CHECKOUT_SETTINGS, SET_CHECKOUT_SHIPPING_ISCOMPLETE, SET_GLOBAL_ADDRESS_CONFIG, SET_GLOBAL_ISB3USER, SET_GLOBAL_ISPENDING, SET_GLOBAL_LOADING_STAGE, SET_GLOBAL_QUOTEID, SET_INVOICE_CONFIG, SHOW_GLOBAL_ERROR } from '../actionTypes'

const defaultState = {
  error: undefined,
  loadingStage: '',
  isB3User: detectB3User(),
  isPending: true,
  checkoutSettings: {},
  checkoutShippingIsComplete: false,
  quoteId: storage.quoteCheckoutId.getValue() || '',
  isEnabledAddressLabel: storage.isEnabledAddressLabel.getValue(),
  invoiceVersion: 0,
  creditInfo: {
    disableBtn: false,
    creditHold: false,
    errorType: 0,
  }
}

export default (state = defaultState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case SET_GLOBAL_LOADING_STAGE: return { ...state, loadingStage: action.payload}

    case SHOW_GLOBAL_ERROR: return { ...state, error: action.payload }

    case SET_GLOBAL_ISB3USER: return { ...state, isB3User: action.payload }

    case SET_GLOBAL_ISPENDING: return { ...state, isPending: action.payload }

    case SET_GLOBAL_QUOTEID: return { ...state, isPending: action.payload }

    case SET_GLOBAL_ADDRESS_CONFIG: return { ...state, isEnabledAddressLabel: action.payload }

    case SET_CHECKOUT_SETTINGS: return { ...state, checkoutSettings: action.payload }

    case SET_CHECKOUT_SHIPPING_ISCOMPLETE: return { ...state, checkoutShippingIsComplete: action.payload }

    case SET_INVOICE_CONFIG: return { ...state, invoiceVersion: action.payload }

    case SET_CHECKOUT_CREDIT_SETTINGS: return {...state, creditInfo: action.payload}

    default: return state
  }
}
